import BaseValidator from "./BaseValidator";

const decimalNumberValidator = Object.create(BaseValidator);

decimalNumberValidator.validateAgainstRegex =
  /[0-9]{4}-(?:0[0-9]|1[0-2])-(?:[0-2][0-9]|3[0-1])/i;

export default decimalNumberValidator.init();
